import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['first-time-title']),
    firstTimeReporting: yesNoUI(content['first-time-question']),
  },
  schema: {
    type: 'object',
    required: ['firstTimeReporting'],
    properties: {
      firstTimeReporting: {
        type: 'boolean',
      },
    },
  },
};
